import { User } from '../types/user'
export const users: User[] = [
  {
    id: '1',
    username: 'admin',
    password: 'admin123',
    role: 'admin',
    fullName: 'Administrateur Principal',
    phone: '+223 76 12 34 56',
    address: 'Bamako, ACI 2000',
  },
  {
    id: '2',
    username: 'supervisor1',
    password: 'super123',
    role: 'supervisor',
    fullName: 'Mamadou Traoré',
    phone: '+223 76 23 45 67',
    address: 'Bamako, Hamdallaye',
    assignedStationId: '1',
  },
  {
    id: '3',
    username: 'supervisor2',
    password: 'super123',
    role: 'supervisor',
    fullName: 'Fatoumata Coulibaly',
    phone: '+223 76 34 56 78',
    address: 'Bamako, Badalabougou',
    assignedStationId: '2',
  },
  {
    id: '4',
    username: 'generalsuper',
    password: 'gensuper123',
    role: 'general-supervisor',
    fullName: 'Seydou Diarra',
    phone: '+223 76 11 22 33',
    address: 'Bamako, Point G',
  },
  {
    id: '5',
    username: 'operator1',
    password: 'oper123',
    role: 'operator',
    fullName: 'Ibrahim Keita',
    phone: '+223 76 45 67 89',
    address: 'Bamako, Hippodrome',
    assignedStationId: '1',
  },
  {
    id: '6',
    username: 'operator2',
    password: 'oper123',
    role: 'operator',
    fullName: 'Aminata Diallo',
    phone: '+223 76 56 78 90',
    address: 'Bamako, Kalaban Coura',
    assignedStationId: '3',
  },
]
